module.exports = __webpack_public_path__ + "img/creative-commons-sa.a4620d81.svg";